import { useMutation } from '../';
import { updateQuicksightDashboard } from '../mutations';

export function useUpdateQuicksightDashboard() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(updateQuicksightDashboard, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.updateQuicksightDashboard.id);
      }
    });
  };

  return { data, isLoading, run };
}
